module.exports = __webpack_public_path__ + "e104704cd04bb0cb7c7221284727f7c1.svg";